"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputField = void 0;
const react_1 = __importDefault(require("react"));
const popovers_1 = require("../../modals/popovers");
const __1 = require("..");
const InputField_styles_1 = require("./InputField.styles");
const InputField = (props) => {
    const { type, label, errorText, warningText, subtitleText, tooltip, disabled } = props;
    return (react_1.default.createElement(InputField_styles_1.Wrapper, null,
        label && (react_1.default.createElement(InputField_styles_1.HeaderWrapper, { "$isDisabled": disabled },
            react_1.default.createElement(InputField_styles_1.Label, { htmlFor: props.id }, label),
            tooltip && react_1.default.createElement(popovers_1.Tooltip, { message: tooltip }))),
        react_1.default.createElement(InputField_styles_1.InputWrapper, null,
            type === "number" && react_1.default.createElement(__1.NumberInputField, Object.assign({}, props)),
            type === "select" && react_1.default.createElement(__1.SelectInputField, Object.assign({}, props)),
            type === "text" && react_1.default.createElement(__1.TextInputField, Object.assign({}, props))),
        (errorText || warningText || subtitleText) && (react_1.default.createElement(InputField_styles_1.HelperText, { "$hasError": !!errorText, "$hasWarning": !!warningText }, errorText || warningText || subtitleText || ""))));
};
exports.InputField = InputField;
//# sourceMappingURL=InputField.js.map